module.exports = __webpack_public_path__ + "static/media/ee_logo.63b7ecf1.svg";